export { default } from 'ember-sortable/modifiers/sortable-item';
